import { Box, Typography } from "@mui/material";
import VerityIcon from "../../../../../../../chrome-extension/src/pages/toolbar/resource/verityIcon.svg?react";
import SidePanel from "../components/SidePanel";
import styles from "./ScheduleInterviewLayout.module.css";

type ScheduleInterviewLayoutProps = {
	stepper: React.ReactNode;
	nextButton: React.ReactNode;
	backButton: React.ReactNode;
	children: React.ReactNode;
};

export default function ScheduleInterviewLayout({
	stepper,
	nextButton,
	backButton,
	children,
}: ScheduleInterviewLayoutProps) {
	return (
		<Box className={styles.grid}>
			<Box marginLeft="10px">
				<div className={styles.sidebar}>
					<div className={styles.header}>
						<VerityIcon />
						<Typography>Schedule Interview</Typography>
					</div>

					{stepper}
				</div>
			</Box>
			<Box overflow={"auto"} marginRight="10px">
				<div className={styles.content}>
					{children}

					<SidePanel />
				</div>
			</Box>
			<Box gridColumn="span 2">
				<hr />
			</Box>
			<Box gridColumn="span 2">
				<div className={styles.actions}>
					{backButton}
					{nextButton}
				</div>
			</Box>
		</Box>
	);
}
